import { __ } from '@wordpress/i18n';
import {
  MediaUpload,
  MediaUploadCheck,
} from '@wordpress/block-editor';
import {
  PanelBody,
  TextControl,
  Button,
} from '@wordpress/components';
import { Fragment } from '@wordpress/element';

const Footer = ({ signature, setAttributes, footerPanel, isFooterVisible, footerLink, footerBtnText, footerBtnLink, signatureImageUrl}) => {
  
    return (
        <div className="footer-wrap" id="section9">
            <PanelBody
                title={__('Footer', 'cv-builder')}
                className={`bwdcvs-tab-heading ${isFooterVisible ? '' : 'bwdcvs-active'}`}
                initialOpen={footerPanel}
            >
                <Fragment>
                    <MediaUploadCheck>
                        <MediaUpload
                            onSelect={(image) =>
                                setAttributes({
                                    signature: {
                                        url: image.url,
                                        alt: image.alt,
                                    },
                                })
                            }
                            allowedTypes={['image']}
                            value={signature?.id}
                            render={({ open }) => (
                                <div className="bwdtm-image-control">
                                    {signature ? (
                                        <div className="bwdtm-image-preview-container">
                                            <Button
                                                className="bwdtm-image-preview-wrapper"
                                                onClick={open}
                                            >
                                                <img
                                                    src={
                                                        signature.url
                                                    }
                                                    alt={
                                                        signature.alt ||
                                                        'Preview'
                                                    }
                                                    className="bwdtm-image-preview"
                                                />
                                                <span className="bwdtm-edit-icon">
                                                    <i className="dashicons dashicons-edit"></i>
                                                </span>
                                            </Button>
                                            <Button
                                                className="bwdtm-close-icon"
                                                onClick={() =>
                                                    setAttributes({
                                                        signature:
                                                            null,
                                                    })
                                                }
                                            >
                                                <i className="dashicons dashicons-dismiss"></i>
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button
                                            className="bwdtm-placeholder-image signature"
                                            onClick={open}
                                        >
                                            <img
                                                src={
                                                    signatureImageUrl
                                                }
                                                alt="Placeholder"
                                                className="bwdtm-placeholder-image-preview"
                                            />
                                            <span>
                                                {__(
                                                    'Click to Upload Signature',
                                                    'cv-builder'
                                                )}
                                            </span>
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </MediaUploadCheck>
                    <div className="bwd-footer-input-wrap">
                        <TextControl
                            label={__(
                                'Youtube Link',
                                'cv-builder'
                            )}
                            value={footerLink}
                            onChange={(value) =>
                                setAttributes({ footerLink: value })
                            }
                        />
                        <TextControl
                            label={__(
                                'Button Text',
                                'cv-builder'
                            )}
                            value={footerBtnText}
                            onChange={(value) =>
                                setAttributes({
                                    footerBtnText: value,
                                })
                            }
                        />
                        <TextControl
                            label={__(
                                'Button Link',
                                'cv-builder'
                            )}
                            value={footerBtnLink}
                            onChange={(value) =>
                                setAttributes({
                                    footerBtnLink: value,
                                })
                            }
                        />
                    </div>
                </Fragment>
            </PanelBody>
            <Button
                className="bwdtm-toggle-visibility"
                icon={isFooterVisible ? 'visibility' : 'hidden'}
                label={
                    isFooterVisible ? 'Hide Footer' : 'Show Footer'
                }
                onClick={() =>
                    setAttributes({
                        isFooterVisible: !isFooterVisible,
                    })
                }
            />
        </div>
    )
}

export default Footer